import { render } from "./snackbar-item.vue?vue&type=template&id=46ebe59e&ts=true"
import script from "./snackbar-item.vue?vue&type=script&lang=ts"
export * from "./snackbar-item.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\src\\BusinessLuchs_CRM\\frontend-agent\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__